import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import localForage from 'localforage';
import * as memoryDriver from 'localforage-driver-memory';
import checkout from '@/feature/checkout/checkout.store';
import checkoutFallback from '@/feature/checkoutFallback/checkoutFallback.store';
import checkoutRedirect from '@/feature/checkoutRedirect/checkoutRedirect.store';
import preQualify from '@/feature/prequalify/preQualify.store';
import onboarding from '@/feature/onboarding/onboarding.store';
import retargeting from '@/feature/retargeting/retargeting.store';
import tenant from '@/feature/tenant/tenant.store';
import login from '@/feature/login/login.store';
import portal from '@/feature/portal/portal.store';
import guarantor from '@/feature/guarantor/guarantor.store';
import paymentLink from '@/feature/paymentLink/paymentLink.store';
import onboardingV2 from '@/feature/onboarding-v2/onboardingV2.store';
import onboardingMinified from '@/feature/minified-onboarding/minified-onboarding.store';
import installmentsStore from '@/feature/installments/installments.store';
import tracking from '@/feature/login/tracking.store';
import auth from './auth.store';
import track from './track.store';
import theme from './theme.store';

Vue.use(Vuex);

localForage.defineDriver(memoryDriver);
localForage
  .setDriver([
    localForage.LOCALSTORAGE,
    localForage.INDEXEDDB,
    localForage.WEBSQL,
    // eslint-disable-next-line no-underscore-dangle
    memoryDriver._driver,
  ]);

const vuexLocal = new VuexPersistence({
  strictMode: true,
  storage: localForage,
  asyncStorage: true,
  reducer: (state) => ({
    checkout: state.checkout,
    preQualify: state.preQualify,
    auth: state.auth,
    track: state.track,
    portal: {
      firstTimeApproved: state.portal.firstTimeApproved,
      user: state.portal.user,
      bvShowed: state.portal.bvShowed,
    },
    proposal: state.proposal,
  }),
  filter: ({ type }) => ![
    'checkout/toggleSummarySkeleton',
    'checkout/toggleDownPaymentValueSkeleton',
  ].includes(type),
});

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    checkout,
    checkoutFallback,
    checkoutRedirect,
    preQualify,
    onboarding,
    retargeting,
    auth,
    track,
    tracking,
    login,
    theme,
    portal,
    tenant,
    guarantor,
    paymentLink,
    onboardingV2,
    installments: installmentsStore,
    minifiedOnboarding: onboardingMinified,
  },
  mutations: {
    RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION,
  },
});
